"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entryMarkIsValid = exports.validateEntryMark = exports.EntryMarkError = void 0;
var EntryMarkError;
(function (EntryMarkError) {
    EntryMarkError["MISSING"] = "Missing mark";
    EntryMarkError["INVALID"] = "Invalid entry";
    EntryMarkError["EXCEEDS_MAX_MARK_VALUE"] = "Exceeds max mark value";
})(EntryMarkError = exports.EntryMarkError || (exports.EntryMarkError = {}));
const validateEntryMark = (value, maxMark) => {
    const validNumbersOnly = /^[0-9]+$/;
    if (value.length === 0) {
        return EntryMarkError.MISSING;
    }
    if (!validNumbersOnly.test(value)) {
        return EntryMarkError.INVALID;
    }
    if (maxMark && Number(value) > maxMark) {
        return EntryMarkError.EXCEEDS_MAX_MARK_VALUE;
    }
};
exports.validateEntryMark = validateEntryMark;
const entryMarkIsValid = (mark, absent, maxMark, markHidden) => {
    if (absent || markHidden) {
        return true;
    }
    if (mark == null || mark < 0) {
        return false;
    }
    if (maxMark) {
        return maxMark >= mark;
    }
    return true;
};
exports.entryMarkIsValid = entryMarkIsValid;
